import React, { useEffect, useState } from 'react';
import moment from 'moment';

//Componentes
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';
import redestinacao_api from '../../../api/redestinacao_api';
import { showMessage } from 'helpers/message';
import FichaReceberResiduos from './FichaReceberResiduos';


function ReceberResiduos({ permissao }) {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle para exibição da tela de ficha do gerador
    const [ficha, setFicha] = useState(null);

    const [listRedestinacoesReceber, setListRedestinacoesReceber] = useState([]);

    //Cabeçalhos  da tabela de entrada de residuos
    const headersTabela = [
        { value: "Data Registro", objectValue: "dataRegistro" },
        { value: "Status", objectValue: "status" },
        { value: "Transportador", objectValue: "transportadorFantasia" },
        { value: "Destino origem", objectValue: "destinoOrigem" },
        { value: "Veiculo", objectValue: "placaVeiculo" },
        { value: "Data Coleta", objectValue: "dataColeta" },
    ];

    const loadRedestinacoesRecebidas = () => {
        setLoading(true)
        redestinacao_api.GetListReceberResiduos()
            .then(response => {
                response.data = response.data.map(value => {
                    value.dataRegistro = moment(value.dataRegistro).format("DD/MM/YYYY");
                    value.dataColeta = value.dataColeta ? moment(value.dataColeta).format("DD/MM/YYYY") : ""
                    return value;
                })
                setListRedestinacoesReceber(response.data)
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
    }

    useEffect(() => {
        loadRedestinacoesRecebidas()
    }, []);

    //Função do botão visualizar da lista
    const visualizar = (item) => { setFicha(item.id) };

    //Variavel que guarda as ações da tabela
    const actions = [actionsTable.visualizar(visualizar)];

    const btnVoltar = () => {
        setFicha(null)
        loadRedestinacoesRecebidas();
    }

    if (ficha) {
        return <FichaReceberResiduos
            id={ficha}
            btnVoltar={btnVoltar}
            permissao={permissao}
        />
    }

    return <MainCard
        noCard
    >
        {loading && <Loading />}
        <TabelaListagem
            actions={actions}
            title={"Entrada de Redestinação"}
            options={{ print: false, search: true, pagination: true }}
            headers={headersTabela}
            items={listRedestinacoesReceber}
        />
    </MainCard>;
}

export default ReceberResiduos;
